import { logging } from '@cornerstonejs/utils';
export const { getRootLogger, getLogger, cs3dLog, metadataLog, coreLog, toolsLog, adaptersLog, loaderLog, niftiVolumeLoaderLog, polySegLog, labelmapInterpolationLog, aiLog, examplesLog, dicomConsistencyLog, imageConsistencyLog, log, } = logging;
export const { workerLog } = logging;
